export const keyBox = {
  operateClick: 'n.5240.11039.0', // 钥匙盒页面-申领钥匙盒点击
  goDetail: 'n.5240.11041.0', // 钥匙盒页面-签约详情点击

  signClick: 'n.5234.11040.0', // 钥匙盒页面-完成钥匙盒签约点击
  passwordClick: 'n.5234.11042.0', // 钥匙盒页面-密码修改点击
  passwordCancel: 'n.5234.11043.0', // 钥匙盒页面-密码修改弹窗-取消点击
  passwordSubmit: 'n.5234.11044.0' // 钥匙盒页面-密码修改弹窗-保存点击
}
